//
// WhatsApp Business CTA helper.
//
// Spec source: Website Build Handoff V1.0 sec. 6 (Functional Requirements —
// WhatsApp routing). Prefilled message + analytics-aware click.
//
// Configure in landing-page/.env:
//   REACT_APP_WHATSAPP_NUMBER=60123456789   (international, no +/spaces)
// If unset, the helper still renders but the link goes to wa.me's generic
// home page so nothing 404s in dev.
//

// Fallback to the client-provided care-team number (per PDF 2026-07-12) so
// every WhatsApp CTA on the site works even if REACT_APP_WHATSAPP_NUMBER is
// unset in the current environment.
const FALLBACK_NUMBER = '601120801876';
const RAW = process.env.REACT_APP_WHATSAPP_NUMBER || FALLBACK_NUMBER;

// Strip everything except digits — wa.me expects E.164 minus the leading +.
export const WHATSAPP_NUMBER = RAW.replace(/\D+/g, '') || FALLBACK_NUMBER;

export const DEFAULT_PREFILL =
  'Hi MyDr.Ai, I would like to start my free AI assessment.';

export function whatsappUrl(prefill = DEFAULT_PREFILL) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  const q = prefill ? `?text=${encodeURIComponent(prefill)}` : '';
  return `${base}${q}`;
}
